export default __webpack_public_path__ + "static/worldServer-089c56a2333c2e333005802e02d52bb9.svg";